import { render, staticRenderFns } from "./CardPlatformSettings.vue?vue&type=template&id=105ef388"
import script from "./CardPlatformSettings.vue?vue&type=script&lang=js"
export * from "./CardPlatformSettings.vue?vue&type=script&lang=js"
import style0 from "./CardPlatformSettings.vue?vue&type=style&index=0&id=105ef388&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports